// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__25tvZ","modalFooterButton":"ModalNotes_modalFooterButton__GldDx"};